import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../images/crown.png'


const _withScopeId = n => (_pushScopeId("data-v-3b2415ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "acEmpty" }
const _hoisted_2 = { class: "acEmpty_wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "acEmpty_row" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "acEmpty_icon"
  })
], -1))
const _hoisted_4 = { class: "acEmpty_row acEmpty_text" }
const _hoisted_5 = { class: "acEmpty_row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "text", {}, () => [
          _createTextVNode(_toDisplayString(_ctx.$t('itEmpty')), 1)
        ], true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.showButton)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: _ctx.link,
              class: "acEmpty_button"
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "buttonText", {}, () => [
                  _createTextVNode(_toDisplayString(_ctx.$t('goTo.main')), 1)
                ], true)
              ]),
              _: 3
            }, 8, ["to"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}